module.exports = __webpack_public_path__ + "static/img/publicity-app.d0327cd.png";


//////////////////
// WEBPACK FOOTER
// ./static/publicity-app.png
// module id = KC7/
// module chunks = 1